<!-- 
 * @description: 
 * @author: 翠山 
 * @date: 2021-03-02 15:20:28 
 * @后台人员:  
!-->
<template>
    <div id="newMedicineCn">
        <van-nav-bar
            class="nav-fixed"
            :border="false"
            :title="title"
            left-arrow
            @click-left="handleClickLeft"
            />
            <div class="main">
                <van-field
                    class="column"
                    v-model="formItem.commonName"
                    name="用户名"
                    label="通用信息"
                    placeholder="请输入药品通用名"
                    required
                    type="textarea"
                    :maxlength="50"
                    border
                    show-word-limit
                />
                <van-cell title="剂量" required>
                    <!-- 使用 title 插槽来自定义标题 -->
                    <template>
                        <div class="stepper">
                            <van-stepper
                                v-model="formItem.jiliang"
                                min="0"
                                input-width="50"
                                max="999"
                                :integer="false"
                                button-size="30px"
                                @change="quantityBlur"
                                />
                            <span>g</span>
                        </div>
                        
                    </template>
                    </van-cell>
                    <div class="submitBtn" @click="validateSubmit">确定</div>
            </div>
                
    </div>
</template>

<script>
import {addMedicine} from '@/api/index'
import { getCookie } from '../../utils/auth'
    export default {
        data(){
            return{
                title:'新增药品',
                formItem:{
                    commonName:'',
                    jiliang:10
                }
            }
        },
        created(){
            console.log(getCookie('native_organSign'))
        },
        methods:{
            validateSubmit(){
                if(this.formItem.commonName===''){
                    this.$toast({
                        message:'请输入通用信息'
                    })
                    return false
                }
                if(this.formItem.jiliang<=0){
                    console.log(123123213)
                    this.$toast({
                        message:'剂量需大于0g'
                    })
                    return false
                }
                this.submit()
            },
            handleClickLeft(){
                console.log('handleClickLeft')
                this.$emit('close')
            },
            quantityBlur(val){
                console.log(val,typeof val)
            },
            async submit(){
                const paramsObj = {
                    commonName:this.formItem.commonName,
                    quantity:this.formItem.jiliang,
                    organSign:getCookie('native_organSign')
                }
                try{
                    const res = await addMedicine(paramsObj)
                    console.log(res)
                    if (res.data.code === 0) {
                        this.$toast({
                            message: '新增成功',
                            duration: 1500
                        })
                        let params = {
                            organSign:getCookie('native_organSign'),
                            commonName: this.formItem.commonName,
                            attributeSpecification: null,
                            useFrequency: null,
                            singleDose: null,
                            singleUnit: null,
                            directions: null,
                            approvalNumber: null,
                            type: null,
                            prescriptionYn: null,
                            manufacturer: null,
                            unitId: null,
                            producingArea: null,
                            systemType: null,
                            unitName: null,
                            remindContent: null,
                            instructionsDto: {
                            usageAndDosage: null,
                            taboo: null
                            },
                            quantity:this.formItem.jiliang,
                            pref:res.data.result
                        }
                        this.$emit('addMedicine',params)
                    }
                }catch(err){
                    console.log(err)
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    #newMedicineCn{
        width:100%;
        height:100vh;
        position:fixed;
        top:0;
        right:0;
        background:white;
        z-index:2000;
        .van-nav-bar{
            z-index:99999!important;
        }
        .main{
            padding:0 5px;
            .submitBtn{
                width: 345px;
                height: 50px;
                background: #01B956;
                border-radius: 25px;
                line-height: 50px;
                text-align: center;
                color: #fff;
                font-size: 18px;
                position: fixed;
                bottom: 20px;
                left: 15px;
            }
            
        }
        
        .column{
            flex-direction: column;
            /deep/ .van-cell__value{
                margin-top:10px;
                background:#F8F8F8;
                textarea{
                    padding:5px 10px;
                    min-height:90px;
                }
                .van-field__word-limit{
                    padding:5px 10px;
                }
            }
        }
        .stepper /deep/{
            display: flex;
            justify-content: flex-end;
            span {
            font-size:14px;
            margin-left: 5px;
            margin-right: 10px;
            &.edit,
            &.delete {
              top: 5px;
            }
          }
          .van-stepper{
              border: 1px solid #efeff5;
              border-radius:20px;
              padding:0 5px;
          }
          .van-stepper__minus,
          .van-stepper__plus {
            width: 26px !important;
            height: 26px !important;
            border: none;
            border-radius: 50%;
            background:white!important;
            color:black;
          }
          .van-stepper__minus--disabled, .van-stepper__plus--disabled{
              background:white!important;
          }
          .van-stepper__input {
            background-color: #fff!important;
            width:40px!important;
          }
        }
        
    }
    
</style>